<div class="table-row">
  <div class="table-item">{{ customization.name }}</div>
  <div class="table-item hide-on-med-and-down">{{ customization.clientName }}</div>
  <div class="table-item hide-on-med-and-down">{{ customization.defaultForClient ? '*' : '' }}</div>
  <div class="table-item hide-on-med-and-down">
    {{ customization.defaultForLanguage ? customization.defaultForLanguage : '' }}
  </div>
  <div class="table-item hide-on-med-and-down">{{ customization.content ? customization.content.length : '0' }}</div>
  <div class="table-item">
    <gl-button
      icon
      icon-center="glicon-edit"
      [routerLink]="['/customizations', customization.id]"
      class="right"
      title="{{ 'actions.edit' | translate }} {{ customization.name }}"
      *lmsProfileGuard="'customizations.edit'"
    >
    </gl-button>
    <ng-content select="[row-actions]"></ng-content>
  </div>
</div>
